import { secondAxios as axios } from "../../../../../../../api/axios";
export const createTimesheet = async ({ timesheet, taskId, accessToken }) => {
  // send timesheet along with taskId(from URI / state)
  // Ensure progress is a number and include taskId in the data
  const normalizedTimesheet = {
    ...timesheet,
    workDone: timesheet.workDone || timesheet.remarks,
    progress: timesheet.progress != null ? Number(timesheet.progress) : 0,
    taskId,
  };
  // Remove remarks if workDone is being used
  if (normalizedTimesheet.remarks && normalizedTimesheet.workDone) {
    delete normalizedTimesheet.remarks;
  }
  return await axios.post(
    '/timesheet/create',
    normalizedTimesheet,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
};

export const getAllTimesheets = async ({ taskId, accessToken }) => {
  console.log('getting time sheets ', taskId, accessToken);

  const { data } = await axios.get('/timesheet/all/' + taskId, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return data;
};
export const getOneTimesheet = async () => {};

export const updateTimesheet = async ({ timesheet, taskId, accessToken }) => {
  // Ensure progress is a number and include taskId in the data
  const normalizedTimesheet = {
    ...timesheet,
    workDone: timesheet.workDone || timesheet.remarks,
    progress: timesheet.progress != null ? Number(timesheet.progress) : 0,
    taskId,
  };
  // Remove remarks if workDone is being used
  if (normalizedTimesheet.remarks && normalizedTimesheet.workDone) {
    delete normalizedTimesheet.remarks;
  }
  return await axios.put(
    '/timesheet/update/',
    normalizedTimesheet,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
};

export const deleteTimesheet = async ({ timesheetId, accessToken }) => {
  console.log({ timesheetId, accessToken }, 'to be deleted');
  return await axios.delete(`/timesheet/${timesheetId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

